import React from 'react';
import cn from 'classnames';
import './BoxShadow.scss';

export default React.createClass({
	propTypes: {
		dist: React.PropTypes.oneOf(['flush', 'subtle', 'low', 'med', 'high']),
	},
	getDefaultProps() {
		return {
			dist: 'subtle',
		};
	},
	render() {
		const dist = this.props.dist;
		const classes = cn([
			'box_shadow',
			`bs--dist_${dist}`,
			this.props.className,
		]);
		return <div className={classes}>{this.props.children}</div>;
	}
});



/** WEBPACK FOOTER **
 ** core/client/rawr/style/BoxShadow.jsx
 **/